import { z } from "zod";
import { dmaCalculationMetadataDtoSchema } from "./dma-calculation-metadata.schema";
export const dmaCalculationResponseDtoSchema = z.object({
    id: z.string(),
    metadata: dmaCalculationMetadataDtoSchema,
});
